import React from "react";

import {
  AuthOption,
  AuthOptionType,
  Connector,
  IntegrationSetupStepType,
  NonStepPageType,
  RegisteredUser
} from "../../../config/types";
import {
  TypeForLinkingFlowFormDataProperty as PropertyTypes,
  WritableFormDataPropertiesForStepType as WritableTypeProperties
} from "./ConnectorSetupPageRoot";

const noop = () => {};

/**
 * Require at least one property from a mapped type T to be set.
 */
type AtLeastOne<T> = Partial<T> & { [K in keyof T]: Pick<T, K> }[keyof T];

export type FormDataPropertySetter<
  T extends (IntegrationSetupStepType | NonStepPageType) | undefined = never
> = T extends keyof WritableTypeProperties
  ? <P extends WritableTypeProperties[T]>(
      updatedProperties: AtLeastOne<{ [Name in P]: PropertyTypes<Name> }>
    ) => void
  : undefined;

export type IntegrationSetupContextState = {
  connector: Connector;
  authOption: AuthOption;
  registeredUser: RegisteredUser;
  apiBaseURL: string;
  linkToken: string;
  onExit: () => void;
  getFormDataProperty: (property: string) => string | undefined;
  setFormDataProperties: (property: string, value: string) => void | undefined;
  navigateToPreviousStep: (() => void) | undefined;
  navigateToNextStep: () => void;
  submitRegisteredUserFormData: () => void;
  shouldAutomaticallyExitOnOAuthOpen?: boolean;
  shouldBlockOauthOnCookies?: boolean;
  hasThirdPartyCookiesDisabled?: boolean | null;
  registeredUserSecrets?: { [key: string]: string };
};

const IntegrationSetupContext = React.createContext<IntegrationSetupContextState>({
  connector: {
    id: "",
    name: "",
    slug: "",
    logo_url: "",
    auth_options: [],
  },
  authOption: {
    type: AuthOptionType.NONE,
    name: "None",
  },
  registeredUser: {
    id: "",
    name: "",
    origin_id: "",
  },
  apiBaseURL: "",
  linkToken: "",
  onExit: noop,
  getFormDataProperty: () => undefined,
  setFormDataProperties: () => undefined,
  navigateToPreviousStep: noop,
  navigateToNextStep: noop,
  submitRegisteredUserFormData: noop,
  hasThirdPartyCookiesDisabled: null,
  registeredUserSecrets: undefined,
});
export default IntegrationSetupContext;
